import { useSetFeedPause } from '@/api/callcenter/dashboard/setFeedPause';
import { Label } from '@/components/ui/elements/label';
import { Switch } from '@/components/ui/elements/switch';
import { Muted } from '@/components/ui/typography/Typography';

type FeedPauseSwitchProps = {
  feedPaused: boolean;
};

const FEED_PAUSE_SWITCH_ID = 'feed-pause-switch';

export const FeedPauseSwitch = ({ feedPaused }: FeedPauseSwitchProps) => {
  const setFeedPause = useSetFeedPause();

  return (
    <div className="flex flex-col items-end gap-1">
      <div className="flex items-center gap-2">
        <Label htmlFor={FEED_PAUSE_SWITCH_ID}>Pause my feed</Label>
        {/* Checked state is purely prop-driven (server truth via the
            optimistic cache useSetFeedPause maintains) -- no local useState
            mirror here, so a failed toggle's rollback is reflected
            automatically once the prop flows back through. */}
        <Switch
          id={FEED_PAUSE_SWITCH_ID}
          checked={feedPaused}
          onCheckedChange={(checked) => setFeedPause.mutate(checked)}
        />
      </div>
      <Muted>Pausing returns waiting offers to the pool.</Muted>
    </div>
  );
};
